import { OrdersService } from '@/backend/market'
import { NoteRepository } from '../../domain/repositories/NoteRepository'
import { NoteMiniEntity } from '../../domain/entities/NoteMiniEntity'
import type { CreateUpdateNoteEntity } from '../../domain/entities/CreateUpdateNoteEntity'
import { CreateUpdateNoteModel } from '../models/CreateUpdateNoteModel'
import { NoteMiniModel } from '../models/NoteMiniModel'

export class NoteRepositoryImpl implements NoteRepository {
  async getNoteById(id: string): Promise<NoteMiniEntity[] | { error: true }> {
    const response = await OrdersService.getOrderAdminNoteAdmin({
      id: id.toString()
    })

    if (!response.orderAdminNotes) {
      return []
    }

    const noteMiniModels = response.orderAdminNotes.map((note) => new NoteMiniModel(note))
    return noteMiniModels
  }

  async createNote(data: CreateUpdateNoteEntity): Promise<{ success: true } | { error: true }> {
    const createUpdateNoteModel = new CreateUpdateNoteModel(data)
    await OrdersService.postOrderAdminNoteAdmin({
      orderAdminNoteId: data.orderId!.toString(),
      requestBody: {
        adminType: createUpdateNoteModel.adminType,
        note: createUpdateNoteModel.note
      }
    })
    return { success: true }
  }

  async updateNote(data: CreateUpdateNoteEntity): Promise<{ success: true } | { error: true }> {
    const createUpdateNoteModel = new CreateUpdateNoteModel(data)
    try {
      await OrdersService.putOrderAdminNoteAdmin({
        orderAdminNoteId: data.id!.toString(),
        requestBody: {
          adminType: createUpdateNoteModel.adminType,
          note: createUpdateNoteModel.note
        }
      })
      return { success: true }
    } catch {
      return { error: true }
    }
  }

  async deleteNote(id: string): Promise<{ success: true } | { error: true }> {
    try {
      await OrdersService.deleteOrderAdminNoteAdmin({
        orderAdminNoteId: id.toString()
      })
      return { success: true }
    } catch {
      return { error: true }
    }
  }
}
